module.exports = __webpack_public_path__ + "img/必學日語.15cc503e.png";